import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useAuth } from '../../../shared/hooks/useApi/useAuth';
import { useAuthTokenStore } from '../../../shared/store/authStore';
import { useAdminMember } from '../../share/hook/useAdminMember';
import { formatBytes } from '../../../shared/util/formatBytes';


const MemberDashboard: React.FC = () => {
  const { user } = useAuth();
  const { authToken } = useAuthTokenStore();
  const { overall, getOverall } = useAdminMember();

  useEffect(() => {
    const getOverallWithApi = async () => {
      if (!user) return;
      if (!authToken) return;
      console.log("getting overall...");
      await getOverall(user.aui);
    }
    getOverallWithApi();
  }, [user, authToken]);

  if (!overall) return null;

  const usagePercentage = ((overall.storageOverall.totalOriginBytes / overall.storageOverall.totalBytes) * 100).toFixed(2);
  const subscriptionPercentage = overall.memberCount > 0 
    ? (((overall.subscriptionCount || 0) / overall.memberCount) * 100).toFixed(2)
    : '0.00';


  return (
    <MemberDashboardContainer>
      <DashboardContainer>
        <Total>
          Total Members: {overall.memberCount}
        </Total>
        |
        <Total>
          Subscribed: {overall.subscriptionCount || 0} ({subscriptionPercentage}%)
        </Total>
      </DashboardContainer>
      <DashboardContainer>
        <Total>
          Total Storage: {formatBytes(overall.storageOverall.totalBytes, true)}
        </Total>
        |
        <Total>
          Original Storage: {formatBytes(overall.storageOverall.totalOriginBytes, true)} ({usagePercentage}%)
        </Total>
        |
        <Total>
          Total Files: {overall.storageOverall.totalFiles}
        </Total>
      </DashboardContainer>
    </MemberDashboardContainer>
  )
}

const MemberDashboardContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const DashboardContainer = styled.div`
  width: 100%;
  height: fit-content;

  display: flex;
  padding: 4px 0;
  gap: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
  
`;

const Total = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  ${({ theme }) => theme.typography.Body_04};
`;

export default MemberDashboard; 